import React from "react";
import { attributes } from "../data/brand";
import { SectionLabel } from "./SectionLabel";
type AttributesBandProps = {
  label?: string;
};
export function AttributesBand({
  label = "Principles"
}: AttributesBandProps) {
  return <section aria-labelledby="attributes-quote" className="bg-navy text-ivory" data-id="element-30" data-mp="33f1agiwmlu0">
      <div className="shell py-24 md:py-32" data-id="element-31" data-mp="3u73oxwececv7">
        <SectionLabel tone="inverse" data-id="element-32" data-mp="3uahsv92nmu4r">{label}</SectionLabel>
        <blockquote id="attributes-quote" className="mt-10 max-w-5xl font-display text-[clamp(2rem,4.4vw,4rem)] italic leading-[1.12] text-ivory" data-id="element-33" data-mp="cyqhz4dvi34e">
          “Nothing here is going to fall through the cracks — and I no longer have to think about it.”
        </blockquote>
        <p className="mt-6 text-sm text-ivory/60" data-id="element-34" data-mp="hs1f2dsvv5j4">What a Constant client should feel.</p>

        <dl className="mt-16 grid grid-cols-1 border-t border-ivory/20 sm:grid-cols-2 lg:grid-cols-3" data-id="element-35" data-mp="vrknz8tiqkwh">
          {attributes.map(a => <div key={a.name} className="border-b border-ivory/15 py-8 pr-8" data-id="element-36" data-mp="qpbvedkk5kuw">
              <dt className="font-display text-2xl text-ivory" data-id="element-37" data-mp="2mmga4an1qxri">{a.name}</dt>
              <dd className="mt-3 max-w-xs text-[15px] leading-relaxed text-ivory/70" data-id="element-38" data-mp="2rl16fyz6gxao">{a.line}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}